import { createElement, FC, ReactNode } from 'react';

export interface PreHeadingProps {
  children?: ReactNode;
  size?: string;
  color?: string;
  element?: string;
  className?: string;
  dot?: boolean;
}

const SIZES = {
  xs: 'text-xs md:text-xs tracking-widest',
  sm: 'text-xs md:text-sm tracking-widest',
  md: 'text-sm md:text-base tracking-widest',
  lg: 'text-base md:text-lg tracking-wider',
};

const COLOR = {
  primary: 'text-theme-primary',
  white: 'text-white',
  black: 'text-black',
  gray: 'text-theme-grey',
};
// const DEFAULT_COLOR = 'text-black';

const PreHeading: FC<PreHeadingProps> = ({
  children,
  size = 'md',
  color = 'primary',
  element = 'h2',
  className = '',
}) => {
  const preHeadingSizes = SIZES[size] || size;
  const preHeadingColor = COLOR[color] || color;

  return createElement(
    element,
    {
      className: `font-heading font-light uppercase inline-flex items-center ${preHeadingSizes} ${preHeadingColor} ${
        className && className
      }`,
    },
    children
  );
};

export default PreHeading;
